import { Component, HostListener, ViewChild, ElementRef, AfterViewChecked, OnInit } from '@angular/core';
import { WhatComponent } from './components/what/what.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { GoogleFormsService } from './services/google-forms.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild('intro', {static: false, read: ElementRef}) intro: ElementRef;
  @ViewChild('what', {static: false, read: ElementRef}) what: ElementRef;
  @ViewChild('treatment', {static: false, read: ElementRef}) treatment: ElementRef;
  @ViewChild('questionnaire', {static: false, read: ElementRef}) questionnaire: ElementRef;
  @ViewChild('referral', {static: false, read: ElementRef}) referral: ElementRef;

  fragment: string;

  title = 'heroin-help';

  constructor( private location: Location) {}

  @HostListener('window:scroll', ['$event']) 
  onWindowScroll() {
    const scrollPosition = window.pageYOffset;
    if (scrollPosition <= this.intro.nativeElement.offsetTop) {
      if (this.fragment !== 'intro') {
        this.fragment = 'intro';
        this.location.go('/#intro')
      }
    } else if (scrollPosition <= this.what.nativeElement.offsetTop) {
      if (this.fragment !== 'what') {
        this.fragment = 'what';
        this.location.go('/#what')
      }
    } else if(scrollPosition <= this.treatment.nativeElement.offsetTop) {
      if (this.fragment !== 'treatment') {
        this.fragment = 'treatment';
        this.location.go('/#treatment')
      }
    } else if(scrollPosition <= this.questionnaire.nativeElement.offsetTop) {
      if (this.fragment !== 'questionnaire') {
        this.fragment = 'questionnaire';
        this.location.go('/#questionnaire')
      }
    } else {
      if (this.fragment !== 'referral') {
        this.fragment = 'referral';
        this.location.go('/#referral')
      }
    }
  }
  
}
